export default function () {

    const $ = jQuery;
    const $section = $('.donation');

    if (!$section.length) return;

    const $message = $section.find('.donation__message');

    // "1234,56" or "1234.56" -> 1234.56
    const parse = (str) => parseFloat(String(str).replace(/\./g, '').replace(',', '.')) || 0;

    // -------------------------------------------------------------------------
    // Step 1 — amount: grid presets <-> custom amount
    // -------------------------------------------------------------------------

    const $grid = $section.find('[data-function="donation_packages_grid"]');
    const $custom = $section.find('[data-function="donation_packages_custom"]');
    const $backPackages = $section.find('.donation__back.packages');
    const $description = $section.find('.donation__packages-description');

    // Reflect the currently selected option: show the grid or the custom input,
    // and keep the helper description in sync with the chosen package.
    function updateAmountUI() {
        const $checked = $section.find('input[name="selectable_donation_amount"]:checked');
        const isCustom = $checked.val() === 'custom';

        $grid.css('display', isCustom ? 'none' : '');
        $custom.css('display', isCustom ? 'block' : 'none');
        $backPackages.css('display', isCustom ? 'block' : 'none');

        if (!isCustom) {
            $description.text($checked.data('cta') || '');
        }
    }

    // Resolve the amount to charge from whichever option is active.
    function getAmount() {
        const $checked = $section.find('input[name="selectable_donation_amount"]:checked');
        if (!$checked.length) return 0;

        if ($checked.val() === 'custom') {
            return parse($section.find('input[name="donation_amount"]').val());
        }
        return parseFloat($checked.val()) || 0;
    }

    $section.on('change', 'input[name="selectable_donation_amount"]', updateAmountUI);
    updateAmountUI();

    // -------------------------------------------------------------------------
    // Step 1 — frequency: one-time vs monthly (toggle only rendered when the
    // project allows monthly donations)
    // -------------------------------------------------------------------------

    function isMonthly() {
        return $section.find('input[name="donation_frequency"]:checked').val() === 'monthly';
    }

    // Step 3 shows either the WooCommerce payment methods (one-time) or the
    // monthly SEPA block that redirects to Stripe's hosted subscription page.
    function updatePaymentUI() {
        const monthly = isMonthly();

        $section.find('#order_review').toggle(!monthly);
        $section.find('.donation__monthly').css('display', monthly ? 'flex' : 'none');

        if (monthly) {
            $section.find('[data-function="monthly_amount"]')
                .text('€ ' + getAmount().toFixed(2).replace('.', ','));
        }
    }

    // -------------------------------------------------------------------------
    // Step 2 — company donations: checkbox reveals the company name field
    // -------------------------------------------------------------------------

    function isCompanyDonation() {
        return $('#billing_donate_as_company').is(':checked');
    }

    function updateCompanyUI() {
        $('#billing_company_field').toggle(isCompanyDonation());
    }

    $section.on('change', '#billing_donate_as_company', updateCompanyUI);
    updateCompanyUI();

    // -------------------------------------------------------------------------
    // Step navigation
    // -------------------------------------------------------------------------

    function goToStep(n, scroll) {
        $section.find('.donation__packages').toggleClass('is-active', n === 1);
        $section.find('.donation__details').toggleClass('is-active', n === 2);
        $section.find('.donation__payments').toggleClass('is-active', n === 3);

        // Progress indicator in the header SVG.
        $section.find('#step_2').toggleClass('is-active', n >= 2);
        $section.find('#step_3').toggleClass('is-active', n >= 3);

        if (scroll && $section[0]) {
            $section[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    // Validate the required billing fields before moving on to payment.
    function validateBilling() {
        const required = [
            'billing_first_name',
            'billing_last_name',
            'billing_email',
            'billing_address_1',
            'billing_postcode',
            'billing_city',
        ];

        if (isCompanyDonation()) {
            required.push('billing_company');
        }

        let ok = true;
        let $first = null;

        required.forEach(function (id) {
            const $field = $('#' + id);
            if (!$field.length) return;

            const value = $.trim($field.val() || '');
            let valid = value !== '';

            if (valid && id === 'billing_email') {
                valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            }

            $field.toggleClass('error', !valid);
            if (!valid && !$first) $first = $field;
            if (!valid) ok = false;
        });

        if ($first) $first.trigger('focus');
        return ok;
    }

    // Step 1 -> 2: add the donation to the cart, refresh totals, advance.
    $section.on('click', '[data-action="add_donation_to_cart"]', function () {

        const $btn = $(this);
        const amount = getAmount();

        if (amount < 1) {
            $message.text('Vul een geldig bedrag in.');
            return;
        }

        $message.text('');
        $btn.addClass('is-loading');

        $.post(ajaxURL, {
            action: 'add_donation_to_cart',
            nonce: ajaxNonce,
            amount: amount,
            post_id: $section.data('donation'),
        }).done(function (res) {
            if (res && res.success) {
                if (res.nonces) {
                    if (window.wc_checkout_params) wc_checkout_params.update_order_review_nonce = res.nonces.update_order_review;
                    $('#woocommerce-process-checkout-nonce').val(res.nonces.process_checkout);
                }
                $(document.body).trigger('update_checkout');
                goToStep(2, true);
            } else {
                $message.text((res && res.message) || 'Er ging iets mis.');
            }
        }).fail(function () {
            $message.text('Er ging iets mis. Probeer het opnieuw.');
        }).always(function () {
            $btn.removeClass('is-loading');
        });
    });

    // Step 2 -> 3: validate billing, then show the payment step.
    $section.on('click', '[data-action="choose_donation_payment"]', function () {
        if (!validateBilling()) return;
        updatePaymentUI();
        goToStep(3, true);
    });

    // Monthly: create the Stripe subscription checkout (SEPA-incasso) and
    // send the donor to Stripe's hosted payment page.
    $section.on('click', '[data-action="start_monthly_donation"]', function () {

        const $btn = $(this);
        const $monthlyMessage = $section.find('.donation__monthly-message');

        if ($btn.hasClass('is-loading')) return;

        $monthlyMessage.text('');
        $btn.addClass('is-loading');

        const data = {
            action: 'start_monthly_donation',
            nonce: ajaxNonce,
            post_id: $section.data('donation'),
        };

        [
            'billing_first_name',
            'billing_middle_name',
            'billing_last_name',
            'billing_email',
            'billing_phone',
            'billing_address_1',
            'billing_address_2',
            'billing_postcode',
            'billing_city',
            'billing_country',
            'billing_company',
        ].forEach(function (id) {
            data[id] = $('#' + id).val() || '';
        });

        $.post(ajaxURL, data).done(function (res) {
            if (res && res.success && res.redirect_url) {
                window.location = res.redirect_url;
            } else {
                $monthlyMessage.text((res && res.message) || 'Er ging iets mis.');
                $btn.removeClass('is-loading');
            }
        }).fail(function (xhr) {
            const res = xhr && xhr.responseJSON;
            $monthlyMessage.text((res && res.message) || 'Er ging iets mis. Probeer het opnieuw.');
            $btn.removeClass('is-loading');
        });
    });

    // Step 2 -> 1: back to the amount step.
    $section.on('click', '[data-action="donation_back"]', function () {
        goToStep(1, true);
    });

    // Step 3 -> 2: back to the details step.
    $section.on('click', '[data-action="donation_back_details"]', function () {
        goToStep(2, true);
    });
}
